import { useActionsTrack } from "@/_old/features/analytics";
import IconAIAgents from "@/assets/icons/icon-ai-agents.svg?react";
import { BetaTag } from "@/core/components/floating-chatbot/components/beta-tag";
import { Button } from "@/core/components/ui/button";
import { cn } from "@/core/utils";
import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export const DashboardBannerIA = ({
  direction = "column",
  carousel = false,
}: {
  direction: "column" | "row";
  carousel: boolean;
}) => {
  const [translate] = useTranslation(["insights"]);

  const whatsappUrl =
    "https://wa.me/5511936192671?text=" +
    encodeURIComponent(translate("insights-banner-ia-description") as string);

  const { onActionClick } = useActionsTrack();

  return (
    <div className="p-[1px] rounded-2xl shadow-lg bg-aiStrategy-gradient">
      <div
        className={cn(
          "bg-white rounded-2xl p-4 flex flex-col gap-2",
          direction === "row" &&
            "lg:flex-row lg:items-center lg:justify-between",
          carousel && "min-h-28 justify-center",
        )}
      >
        {/* Header */}
        <div className="flex gap-2 items-center">
          <IconAIAgents className="w-10 h-10 shrink-0" />
          <h2 className="font-sans font-semibold text-heading-7 text-black leading-snug">
            {translate("insights-banner-ia-title-prefix")}{" "}
            <em className="font-serif italic font-bold text-black">
              {translate("insights-banner-ia-title-agent")}
            </em>{" "}
            {translate("insights-banner-ia-title-suffix")}
          </h2>
          <BetaTag />
        </div>

        {/* Body */}
        {!carousel && (
          <p
            className="font-body text-body-14 text-[#333]"
            dangerouslySetInnerHTML={{
              __html: translate("insights-banner-ia-description") as string,
            }}
          />
        )}

        {/* Actions */}
        <div className="flex gap-2 items-center flex-wrap">
          <Button
            className="h-10 px-4 gap-2 rounded-[10px] bg-[#2f2e29] hover:bg-[#1e1e18] !text-white text-body-14 font-body font-medium"
            onClick={() => {
              onActionClick("CLICK_REQUEST_IA_AGENT_ACCESS", "VIEW");
              window.open(whatsappUrl, "_blank");
            }}
          >
            <MessageCircle className="w-4 h-4 shrink-0" />
            {translate("insights-banner-ia-button")}
          </Button>
        </div>
      </div>
    </div>
  );
};
